import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme = {
  primary: '#47266F',
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#00CAE3',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
  icons: {
    iconfont: 'fa',
    values: {
      user: 'fal fa-user',
      user_config: 'fas fa-user-cog',
      user_medical: 'fal fa-users-medical',
      locks: 'fal fa-lock-alt',
      align_right: 'fal fa-align-right',
      clock: 'fal fa-clock',
      close: 'fal fa-times',
      arrow_next: 'fal fa-long-arrow-right',
      arrow_back: 'fal fa-long-arrow-left',
      telephone: 'fal fa-mobile',
      email: 'fal fa-envelope',
      map_marker: 'fal fa-map-marker-alt',
      search: 'fal fa-search',
      check: 'fas fa-check',
      ban: 'fas fa-ban',
      spinner: 'fas fa-spinner',
      plus_circle: 'fas fa-plus-circle',
      edit: 'fal fa-edit',
      trash: 'fal fa-trash-alt',
      camera: 'fal fa-camera',
      plus_square: 'fas fa-plus-square',
      power_off: 'fal fa-power-off',
      euro_sign: 'fas fa-euro-sign',
      info_circle: 'fas fa-info-circle'
    },
  },
})
